<div class="loading-spinner" [ngClass]="{ fullSize: fullSize }">
  <mat-spinner [diameter]="diameter" [strokeWidth]="stroke" color=""></mat-spinner>
</div>
